import { ClientData, ConsolidatedAccountData } from "@shared/types";

export type PortfolioAccountData = ConsolidatedAccountData &
  Partial<ClientData> & { isLoading?: boolean };

export enum AccountsSort {
  NAME = "sort.name",
  STATUS = "sort.status",
  TOTAL = "sort.total",
  AVAILABLE = "sort.available",
  CHANGE = "sort.change",
}

export enum ConnectExchangeTabs {
  QUICK_CONNECT = "create_account.tabs.quick_connect",
  API_KEYS = "create_account.tabs.connect_with_api_keys",
}

export enum PositionsSort {
  SYMBOL = "sort.symbol",
  LEVERAGE = "sort.leverage",
  POSITION_SIZE = "sort.size",
  MARGIN = "sort.margin",
  UNREALIZED_PNL = "sort.u_pnl",
  ENTRY_PRICE = "sort.entry_price",
  PRICE = "sort.price",
  LIQUIDATION_PRICE = "sort.liq_price",
  CHANGE = "sort.change",
}
